import { ConfigProvider, DrawerProps, Grid, ModalProps } from 'antd';
import React from 'react';
import { withTheme } from '../ThemeProvider';
import { Footer as DefaultFooter } from './Footer';
import { Header as DefaultHeader } from './Header';
import { StyledDrawer, StyledModal } from './styles';

export interface IModal extends ModalProps {
  Header?: React.ReactNode;
  Footer?: React.ReactNode;
  title?: string | React.ReactNode;
  icon?: React.ReactNode;
  buttonsList?: React.ReactNode[];
  drawerProps?: DrawerProps;
  theme?: any;
  classes?: {
    body: string;
    mask: string;
    header: string;
    footer: string;
    content: string;
  };
}

const ModalComponent: React.FC<IModal> = ({
  Header,
  Footer,
  title,
  icon,
  buttonsList,
  classes,
  drawerProps,
  ...rest
}) => {
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;

  const headerContent = Header ?? (
    <DefaultHeader title={title} icon={icon} onClick={rest.onCancel} />
  );

  const footerContent = Footer ?? <DefaultFooter buttonsList={buttonsList} />;

  const handleCancel = (e: React.MouseEvent | React.KeyboardEvent) => {
    if (rest.onCancel) {
      rest.onCancel(e as any);
    }
  };

  return (
    <ConfigProvider
      modal={{
        classNames: classes,
      }}
    >
      {isMobile ? (
        <StyledDrawer
          open={rest.open}
          onClose={handleCancel}
          title={headerContent}
          footer={footerContent}
          closable={false}
          placement="bottom"
          {...drawerProps}
        >
          {rest.children}
        </StyledDrawer>
      ) : (
        <StyledModal
          centered
          title={headerContent}
          open={rest.open}
          onOk={rest.onOk}
          footer={footerContent}
          closable={false}
          {...rest}
        >
          {rest.children}
        </StyledModal>
      )}
    </ConfigProvider>
  );
};

export const Modal = withTheme(ModalComponent);
